export default __webpack_public_path__ + "static/transport5-img-ae1053e3a05da860f778f166e76e491d.jpg";